import {
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
  GoalImpactLevel,
  GoalType,
  TaskPriorityOptions,
  TaskType,
} from '@griply/types';

import { goalNoImpactFilterValue } from './goal-list-page-options';

// Order only — the per-view sets decide which rows show. Deleted is trash-internal, never a menu row.
export const filterOptionKeysOrder = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Goal,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Date,
  FilterOptionKeys.Deadline,
  FilterOptionKeys.Duration,
  FilterOptionKeys.Priority,
  FilterOptionKeys.Type,
  FilterOptionKeys.CompletedAt,
  FilterOptionKeys.GoalType,
] as const satisfies readonly FilterOptionKeys[];

export const sortFilterOptionKeys = <K extends FilterOptionKeys>(
  keys: readonly K[],
): K[] =>
  (filterOptionKeysOrder as readonly FilterOptionKeys[]).filter(
    (key): key is K => (keys as readonly FilterOptionKeys[]).includes(key),
  );

export const typeFilterOptions = [
  TaskType.Task,
  TaskType.Habit,
  TaskType.Repeating,
] as const satisfies readonly TaskType[];

export const priorityFilterOptions = [
  TaskPriorityOptions.High,
  TaskPriorityOptions.Medium,
  TaskPriorityOptions.Low,
  TaskPriorityOptions.None,
] as const satisfies readonly TaskPriorityOptions[];

export const goalTypeFilterOptions = [
  GoalType.Goal,
  GoalType.Project,
] as const satisfies readonly GoalType[];

export const goalImpactFilterOptions = [
  GoalImpactLevel.High,
  GoalImpactLevel.Medium,
  GoalImpactLevel.Low,
  goalNoImpactFilterValue,
] as const satisfies readonly (
  | GoalImpactLevel
  | typeof goalNoImpactFilterValue
)[];

// Group boundaries render as separators (web) / sections (mobile).
export const dateFilterPresetGroups = [
  [FilterDocumentDateFilterTypes.Overdue],
  [
    FilterDocumentDateFilterTypes.Today,
    FilterDocumentDateFilterTypes.ThisWeek,
    FilterDocumentDateFilterTypes.NextWeek,
    FilterDocumentDateFilterTypes.Next14Days,
    FilterDocumentDateFilterTypes.ThisMonth,
    FilterDocumentDateFilterTypes.NextMonth,
    FilterDocumentDateFilterTypes.ThisQuarter,
    FilterDocumentDateFilterTypes.NextQuarter,
    FilterDocumentDateFilterTypes.ThisYear,
    FilterDocumentDateFilterTypes.NextYear,
  ],
  [FilterDocumentDateFilterTypes.Custom],
  [
    FilterDocumentDateFilterTypes.NoDeadline,
    FilterDocumentDateFilterTypes.HasDeadline,
  ],
] as const satisfies readonly (readonly FilterDocumentDateFilterTypes[])[];

// Goal-active filters a time window a goal is active in, so the
// no-date/has-date options don't apply.
export const goalActiveFilterPresetGroups = [
  [FilterDocumentDateFilterTypes.Overdue],
  [
    FilterDocumentDateFilterTypes.Today,
    FilterDocumentDateFilterTypes.ThisWeek,
    FilterDocumentDateFilterTypes.NextWeek,
    FilterDocumentDateFilterTypes.Next14Days,
    FilterDocumentDateFilterTypes.ThisMonth,
    FilterDocumentDateFilterTypes.NextMonth,
    FilterDocumentDateFilterTypes.ThisQuarter,
    FilterDocumentDateFilterTypes.NextQuarter,
    FilterDocumentDateFilterTypes.ThisYear,
    FilterDocumentDateFilterTypes.NextYear,
  ],
  [FilterDocumentDateFilterTypes.Custom],
] as const satisfies readonly (readonly FilterDocumentDateFilterTypes[])[];
